export type ApiErrorParams<T> = {
	message: string;
	status: number;
	url: string;
	/** OpenAPI path template, e.g. `/invoices/{invoiceId}`. */
	schemaPath: string;
	method: string;
	data?: T;
	cause?: unknown;
};

export class ApiError<T = unknown> extends Error {
	public readonly status: number;
	public readonly url: string;
	public readonly schemaPath: string;
	public readonly method: string;
	public readonly data?: T;

	constructor({ message, status, url, schemaPath, method, data, cause }: ApiErrorParams<T>) {
		super(message, { cause });
		this.name = 'ApiError';
		this.status = status;
		this.url = url;
		this.schemaPath = schemaPath;
		this.method = method;
		this.data = data;
	}
}
